import { useLayoutEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export function StoryProgress() {
  const fill = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    const context = gsap.context(() => {
      gsap.fromTo(fill.current, { scaleY: 0 }, {
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          trigger: ".story",
          start: "top top",
          end: "bottom bottom",
          scrub: 0.35,
        },
      })
    })
    return () => context.revert()
  }, [])

  return (
    <div className="story-progress" aria-hidden="true">
      <span className="story-progress__label">Reparos</span>
      <div className="story-progress__track"><span ref={fill} /></div>
      <div className="story-progress__points"><i>01</i><i>02</i><i>03</i><i>04</i></div>
    </div>
  )
}
